import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'TextInput',
    props: {
        alignRight: Boolean,
        boldLabel: Boolean,
        clearable: Boolean,
        debounce: Boolean,
        disabled: Boolean,
        fieldMessage: {
            type: String,
            default: null,
        },
        fieldType: {
            type: String,
            default: null,
        },
        inputSize: {
            type: String,
            default: 'md',
        },
        label: {
            type: String,
            default: null,
        },
        maxLength: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        smallLabel: Boolean,
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        highlight: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const classNames = computed(() => {
            const names = [];
            switch (props.inputSize) {
                case 'xs':
                    names.push('TextInput--xs');
                    break;
                case 'sm':
                    names.push('TextInput--sm');
                    break;
                case 'md':
                    names.push('TextInput--md');
            }
            if (props.boldLabel)
                names.push('TextInput--bold-label');
            if (props.highlight)
                names.push('TextInput--highlight');
            if (props.alignRight)
                names.push('TextInput--align-right');
            if (props.smallLabel)
                names.push('TextInput--small-label');
            return names;
        });
        const debounce = (func, wait) => {
            let timeoutId;
            return function fn(...args) {
                if (timeoutId !== undefined) {
                    clearTimeout(timeoutId);
                }
                timeoutId = window.setTimeout(() => {
                    func.apply(this, args);
                }, wait);
            };
        };
        const inputUpdated = debounce((value) => emit('input', value), props.debounce ? 200 : 0);
        return {
            classNames,
            inputUpdated,
        };
    },
});

export { script as default };
